import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enTranslation from "./locales/en.json";
import alTranslation from "./locales/al.json";
import grTranslation from "./locales/gr.json";
// import sqTranslation from "./locales/sq.json";

const resources = {
  al: {
    translation: alTranslation,
  },
  en: {
    translation: enTranslation,
  },
  gr: {
    translation: grTranslation,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
